/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Link component colors
 *
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.3.0
 */

import { FreshAsphalt50, Link } from './palette';

export const linkDefaultColor = Link;
export const linkDefaultColorHover = Link;
export const linkDefaultColorDisabled = FreshAsphalt50;
